import { Component, SimpleChanges, Input } from '@angular/core';
import { RiskimageService } from 'src/app/services/riskimage.service';
import { TotalResultViewModel } from '../../../models/total-result-view-model';

@Component({
  selector: 'app-status',
  templateUrl: './status.component.html',
  styleUrls: ['./status.component.scss']
})
export class StatusComponent {
  @Input() total: TotalResultViewModel | undefined = new TotalResultViewModel();

  @Input() path?: string;

  constructor(public riskimageService: RiskimageService) {
    this.path = this.riskimageService.getRiskLevelMeter(undefined);
  }

  ngOnChanges(changes: SimpleChanges) {

    for (const propName in changes) {

      if (propName !== "total" || !changes[propName].currentValue)
        return;

      this.total = changes[propName].currentValue;
      this.path = this.riskimageService.getRiskLevelMeter(this.total);
    }
  }
}
